// Dynamic, self-serve analytics loader.
// Fetches the owner-configured tracking IDs from the backend and injects
// PostHog, Google Analytics (GA4) and Google Tag Manager only when present.
// Owner manages these in Admin -> Analytics (stored in app_config).

const BACKEND = process.env.REACT_APP_BACKEND_URL;

function injectScript(src, attrs = {}) {
  const s = document.createElement("script");
  s.src = src;
  s.async = true;
  Object.entries(attrs).forEach(([k, v]) => s.setAttribute(k, v));
  document.head.appendChild(s);
  return s;
}

function loadPostHog(key, host) {
  if (!key || window.__owp_posthog_loaded) return;
  window.__owp_posthog_loaded = true;
  /* eslint-disable */
  !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug getPageViewId".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
  /* eslint-enable */
  window.posthog.init(key, {
    api_host: host || "https://us.i.posthog.com",
    person_profiles: "identified_only",
    capture_pageview: true,
  });
}

function loadGA4(id) {
  if (!id || window.__owp_ga4_loaded) return;
  window.__owp_ga4_loaded = true;
  injectScript(`https://www.googletagmanager.com/gtag/js?id=${id}`);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", id);
}

function loadGTM(id) {
  if (!id || window.__owp_gtm_loaded) return;
  window.__owp_gtm_loaded = true;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  injectScript(`https://www.googletagmanager.com/gtm.js?id=${id}`);
}

export async function initAnalytics() {
  if (!BACKEND || window.__owp_analytics_init) return;
  window.__owp_analytics_init = true;
  try {
    const res = await fetch(`${BACKEND}/api/analytics-config`);
    if (!res.ok) return;
    const cfg = await res.json();
    loadPostHog(cfg.posthog_key, cfg.posthog_host);
    loadGA4(cfg.ga4_id);
    loadGTM(cfg.gtm_id);
  } catch {
    /* analytics is best-effort; never block the app */
  }
}
